import { summaryMapper } from 'container/summaryMapper';
import { opinionQuestionMapper } from 'container/opinionQuestionMapper';

import { EngagementScoreMapper } from '../mapper/EngagementScoreMapper';

export const engagementScoreMapper = new EngagementScoreMapper(
  summaryMapper,
  opinionQuestionMapper
);
